module.exports = __webpack_public_path__ + "media/night/116-641ffda1.svg";